import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {ConfirmIcon} from 'shells/icon/svg/confirm-icon';

// @ts-expect-error
import getClasses from '../../mixins/get-classes';

type Props = {
    className?: string;
    getButtonRef?: (arg1?: HTMLElement | null | undefined) => void;
    disabled?: boolean;
    onClick?: () => any;
    onMouseOver?: () => any;
    onMouseOut?: () => any;
};

export class CheckmarkSubmitButton extends React.Component<Props> {
    buttonRef: HTMLButtonElement | null | undefined;
    getClasses = getClasses;

    render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {getButtonRef, ...htmlButtonProps} = this.props;

        return (
            <button
                {...htmlButtonProps}
                ref={this.handleRef}
                type='submit'
                className={this.getClasses('ui-btn ui-btn__checkmark-submit ui-btn--icon')}
            >
                <ConfirmIcon size={30} />
            </button>
        );
    }

    handleRef = (node?: HTMLButtonElement | null) => {
        this.buttonRef = node;

        if (this.props.getButtonRef) {
            this.props.getButtonRef(node);
        }
    };

    handleClick = (...args: any) => {
        if (this.props.onClick) {
            // @ts-expect-error
            this.props.onClick(...args);
        }

        if (this.buttonRef) {
            this.buttonRef.blur();
        }
    };
}
